import { WHATS_NEW_LINK } from "@/v2-common/featureSurface/featureSurface.constants"

// lic.LicenseStatuses codes. 2-6 mirror the states Fenerum reports on a
// subscription; Trial is ours alone (a trial has no billing record at all).
export const LICENSE_STATUS_TRIAL = 1
export const LICENSE_STATUS_ACTIVE = 2
export const LICENSE_STATUS_SCHEDULED = 3
export const LICENSE_STATUS_NOT_RENEWING = 4
export const LICENSE_STATUS_EXPIRED = 5
export const LICENSE_STATUS_NOT_STARTING = 6

// The operator playbook: how to give a customer access, limit it to named
// people and read what they get. Published to the public assets bucket, so
// it opens without a Backoffice session (sales reads it on a phone too).
export const LICENSE_PLAYBOOK_URL =
  "https://assets.placepoint.no/misc/operator-playbook-licensing.html"

// Default width of a Status column that renders LicenseStatusBadge. The pill
// carries a stamp ("Not renewing · ends 11.12.2026", "Trial · 62 days
// overdue"), so the old 150 px clipped the part that says when.
export const LICENSE_STATUS_COLUMN_SIZE = 215

// The statuses that hold seats — the same set acc.CustomerSeatUsage sums
// the seat cap over (Trial, Active, Not renewing); Scheduled has not begun
// and the rest have ended.
export const LICENSE_LIVE_STATUS_CODES: readonly number[] = [
  LICENSE_STATUS_TRIAL,
  LICENSE_STATUS_ACTIVE,
  LICENSE_STATUS_NOT_RENEWING,
]

// Not a lic.LicenseStatuses code: the sentinel User.LicenseStatusCode carries
// when the user's customer holds no license at all (the full-User procs emit
// it so "No license" is filterable server-side). null on the field means the
// user has no owning customer, where license tracking does not apply.
export const LICENSE_STATUS_NONE = 0

// lic.LicenseSources codes: who put the license here, and therefore who may
// change it. Fenerum-derived rows are rewritten on every sync and are
// read-only in the backoffice.
export const LICENSE_SOURCE_FENERUM = 1
export const LICENSE_SOURCE_OPERATOR = 2

// lic.PlanMigrationStatuses codes — the stored conversation states of a license
// migration. "Not started" is no row at all (null on the worklist read).
export const PLAN_MIGRATION_STATUS_IN_DIALOGUE = 1
export const PLAN_MIGRATION_STATUS_AGREED = 2
export const PLAN_MIGRATION_STATUS_DECLINED = 3

// Derived migration outcomes from backoffice.Get_Lic_PlanMigrations — never
// stored: the customer leaving the license is what closes a migration (the change
// is executed in Fenerum, the mirror moves the license).
export const PLAN_MIGRATION_OUTCOME_MOVED = 1
export const PLAN_MIGRATION_OUTCOME_ENDED = 2

// lic.InvoiceFollowUpStatuses codes — the stored dunning conversation
// states. "Not started" is no row; "Paid" is the derived outcome below.
export const INVOICE_FOLLOWUP_STATUS_CONTACTED = 1
export const INVOICE_FOLLOWUP_STATUS_ISSUE = 2

// Derived collections outcome from backoffice.Get_Lic_InvoiceCollections —
// never stored: Fenerum registering the payment is what closes a follow-up.
export const INVOICE_FOLLOWUP_OUTCOME_PAID = 1

// Where disputed/changed invoices go — the collections board's "Email
// Finance" action prefills the recipient and the customer-name subject.
export const FINANCE_COLLECTIONS_EMAIL = "arbo@placepoint.no"

// The consolidated Licensing page: one sidebar entry, three tabbed boards
// (the former /licenses, /billing-accounts and /unlicensed-usage pages). The
// view ids double as tab param values, so the old routes redirect onto their
// tab and the URLs stay readable.
export const LICENSING_PATH = "/licensing"
// The id and the Feature access value are also the console's deep link into
// this page (WHATS_NEW_LINK), so they are defined there.
export const LICENSING_TABS_ID = WHATS_NEW_LINK.tabsId
export const LICENSING_VIEW_PLANS = "plans"
export const LICENSING_VIEW_BILLING_ACCOUNTS = "billing-accounts"
export const LICENSING_VIEW_UNLICENSED_USAGE = "unlicensed-usage"
export const LICENSING_VIEW_FEATURE_GROUPS = "feature-groups"
export const LICENSING_VIEW_ADD_ONS = "add-ons"
export const LICENSING_VIEW_COLLECTIONS = "collections"
export const LICENSING_VIEW_RENEWALS = "renewals"
export const LICENSING_VIEW_CHANGES = WHATS_NEW_LINK.tabValue

// The "no license" choice of the license selects (Radix refuses an empty item
// value). An operator-granted license with no catalog name grants nothing from packages.
export const LICENSE_PLAN_NONE_VALUE = "__none__"
